import { jsxs, jsx } from "react/jsx-runtime";
const IconInfoInvertedSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 .667A7.312 7.312 0 0 0 .667 8 7.312 7.312 0 0 0 8 15.333 7.312 7.312 0 0 0 15.333 8 7.312 7.312 0 0 0 8 .667ZM8 14c-3.333 0-6-2.667-6-6s2.667-6 6-6 6 2.667 6 6-2.667 6-6 6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 7.333c-.4 0-.667.267-.667.667v2.667c0 .4.267.667.667.667s.666-.267.666-.667V8c0-.4-.266-.667-.666-.667Zm.6-2.266C8.6 5 8.533 5 8.533 4.933c0-.066-.067-.066-.067-.066-.2-.2-.466-.267-.733-.134-.067.067-.133.067-.2.134l-.067.066C7.466 5 7.4 5 7.4 5.067c0 .066 0 .066-.067.133v.133c0 .2.067.334.2.467.067.067.133.133.2.133C7.8 6 7.933 6 8 6h.133c.067 0 .067 0 .133-.067.067 0 .067-.066.134-.066l.066-.067a.605.605 0 0 0 .2-.467V5.2c0-.067-.066-.067-.066-.133Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  IconInfoInvertedSvg
};
